import { useEffect, useState } from "react";
import { Logo } from "@/components/Logo";

const links = [
  { id: "releases", label: "Releases", testid: "nav-link-releases" },
  { id: "preview", label: "60s Preview", testid: "nav-link-preview" },
  { id: "playlists", label: "Playlists", testid: "nav-link-playlists" },
  { id: "roster", label: "Roster", testid: "nav-link-roster" },
  { id: "manifesto", label: "Label", testid: "nav-link-label" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <header
      data-testid="main-header-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${scrolled ? "glass-dark border-b border-white/10" : "bg-transparent"}`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <a href="#top" data-testid="ran-logo-link" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }} className="flex items-center gap-3">
          <Logo className="h-7 w-auto" />
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => scrollTo(l.id)}
              className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-slate-400 hover:text-[#00f0ff] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          data-testid="nav-cta-demo"
          onClick={() => scrollTo("contact")}
          className="font-mono-tech text-[11px] tracking-[0.2em] uppercase px-5 py-2.5 bg-[#00f0ff] text-black font-bold hover:bg-white transition-colors"
        >
          Send Demo
        </button>
      </div>
    </header>
  );
};
